import React from 'react';
import { useTranslation } from 'react-i18next';
import { Hero, QuickLinks, UnderDev } from '../blocks/all-blocks';
import '../styles/creations.css';

const Travel = ({ transfile }) => {
  const { t } = useTranslation();

  const quickLinks = [
    { name: t('quickLinks.knowledge'), url: '/knowledge' },
    { name: t('quickLinks.tools'), url: '/tools' },
    { name: t('quickLinks.aboutMe'), url: '/me' }
  ];

  return (
    <div className="cont-body">
      <Hero translation={transfile}/>
      <UnderDev />
      <QuickLinks list={quickLinks} />
    </div>
  );
};

export default Travel;